<template>
  <ValidationObserver ref="object" v-slot="{ invalid, passes }">
    <v-row
      :class="{
        'px-3': $vuetify.breakpoint.mdAndUp,
        'px-2': $vuetify.breakpoint.smAndDown
      }"
    >
      <v-col cols="12" class="d-flex">
        <v-btn
          :disabled="invalid"
          color="primary"
          outlined
          @click="passes(updateProfile)"
        >
          <v-icon left> mdi-square-edit-outline </v-icon>
          <span class="text-transform">Save edits</span>
        </v-btn>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 4" class="pb-0">
        <span class="text-input"
          >First Name <span class="red--text">*</span></span
        >
        <VTextInput
          v-model="profile.firstName"
          :rules="{ required: true }"
          placeholder="Enter First Name"
          solo
        />
      </v-col>
      <v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 4" class="pb-0">
        <span class="text-input"
          >Last Name <span class="red--text">*</span></span
        >
        <VTextInput
          v-model="profile.lastName"
          :rules="{ required: true }"
          placeholder="Enter Last Name"
          solo
        />
      </v-col>
      <!-- <v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 4">
        <span class="text-input">Gender</span>
        <VSelect
          v-model="profile.title"
          :items="titles"
          placeholder="Select Gender"
          outlined
          dense
        />
      </v-col> -->
      <v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 4" class="pb-0">
        <span class="text-input"
          >Email Address <span class="red--text">*</span></span
        >
        <VTextInput
          :disabled="true"
          v-model="profile.email"
          placeholder="Enter Email"
          solo
        />
      </v-col>
      <!-- <v-col
        :cols="$vuetify.breakpoint.xsOnly ? 12 : 4"
        :class="$vuetify.breakpoint.mdAndUp ? 'py-0' : ''"
      >
        <span class="text-input">Date of Birth</span>
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <VTextInput
              v-model="date"
              span="Select your birthday"
              prepend-inner-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></VTextInput>
          </template>
          <v-date-picker
            v-model="date"
            :active-picker.sync="activePicker"
            :max="
              new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10)
            "
            min="1950-01-01"
          ></v-date-picker>
        </v-menu>
      </v-col> -->

      <v-col class="py-0" :cols="$vuetify.breakpoint.xsOnly ? 12 : 4">
        <span class="text-input "
          >Phone Number <span class="red--text">*</span></span
        >
        <VTextInput
          v-model="profile.phone"
          :rules="contactRules"
          prepend-inner-icon="mdi-plus"
          placeholder="Enter Phone Number"
          solo
        />
      </v-col>
      <v-col cols="12" class="pt-4">
        <span class="text-input px-1">Address Details: </span>
        <v-divider></v-divider>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 4" class="pb-0">
        <label class="text-input">Search Address</label>
        <VLocation
          v-model="profile.address"
          placeholder="Search address"
          solo
        />
      </v-col>
      <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 4" class="pb-0">
        <span class="text-input"
          >Street 01 <span class="red--text">*</span></span
        >
        <VTextInput
          v-model="profile.address.street1"
          :rules="{ required: true }"
          placeholder="45 Hendford Hill"
          solo
        />
      </v-col>
      <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 4" class="pb-0">
        <span class="text-input"
          >Street 02 <span class="red--text">*</span></span
        >
        <VTextInput
          v-model="profile.address.street2"
          :rules="{ required: true }"
          placeholder="53 Monks Way"
          solo
        />
      </v-col>
      <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 4" class="py-0">
        <span class="text-input">City <span class="red--text">*</span></span>
        <VTextInput
          v-model="profile.address.city"
          :rules="{ required: true }"
          placeholder="Mountfield"
          solo
        />
      </v-col>
      <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 4" class="py-0">
        <span class="text-input"
          >Postcode <span class="red--text">*</span></span
        >
        <VTextInput
          v-model="profile.address.postcode"
          :rules="postcodeRules"
          placeholder="TN32 4XU"
          solo
        />
      </v-col>
      <!-- <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 4" :class="$vuetify.breakpoint.mdAndUp ? 'pt-0' : ''">
        <span class="text-input"
          >Contact <span class="red--text">*</span></span
        >
        <VTextInput
          v-model="profile.address.contact"
          :rules="contactRules"
          prepend-inner-icon="mdi-plus"
          placeholder="44 7911 123456"
          outlined
          dense
        />
      </v-col> -->
      <v-col v-if="$vuetify.breakpoint.xsOnly" cols="12">
        <div class="logout-section">
          <img src="@/assets/icons/logout-icon.svg" />
          <div class="logout-text" @click="logout()">
            Logout
          </div>
        </div>
      </v-col>
    </v-row>
  </ValidationObserver>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import { VTextInput, VLocation } from "@/components/inputs";
import { ProfileService } from "@/services";
import { mapGetters } from "vuex";
import { AuthMixin } from "@/mixins";
export default {
  name: "EditProfileInformation",
  components: {
    ValidationObserver,
    VTextInput,
    VLocation
  },
  mixins: [AuthMixin],
  props: {
    profileInfo: Object
  },
  data: () => ({
    titles: ["Male", "Female", "N/A"],
    dialog: false,
    profile: {
      firstName: null,
      lastName: null,
      phone: null,
      email: null,
      title: null,
      address: {
        city: "",
        street1: "",
        street2: "",
        postcode: "",
        contact: "",
        location: ""
      }
    },
    contactRules: {
      required: true,
      contactRegex: /^(((44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$/
    },
    postcodeRules: {
      required: true,
      postcodeRegex: /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$/
    },
    activePicker: null,
    date: null,
    menu: false,
    disabled: false
  }),
  computed: {
    ...mapGetters("user", {
      user: "user"
    })
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    }
  },
  methods: {
    async updateProfile() {
      this.$bus.$emit("isSaveEdit", true);
      this.dialog = false;
      const data = {
        address: this.profile.address,
        firstName: this.profile.firstName,
        lastName: this.profile.lastName,
        phone: this.profile.phone,
        title: this.profile.title
      };
      const response = await ProfileService.updateProfile(data);
      if (response) {
        const object = {
          firstName: response.data.firstName,
          lastName: response.data.lastName,
          phone: response.data.phone,
          title: response.data.title,
          address: response.data.address
        };
        this.$emit("updatedProfileInformation", object);
        this.$store.dispatch("user/setUser", response.data);
        this.$bus.$emit("isSaveEdit", false);
        this.$store.dispatch("user/setSnack", "Profile updated");
        this.$store.dispatch("user/setType", "info");
      }
    }
  },
  async mounted() {
    if (this.profileInfo) {
      this.profile.firstName = this.profileInfo.firstName;
      this.profile.lastName = this.profileInfo.lastName;
      this.profile.phone = this.profileInfo.phone;
      this.profile.email = this.profileInfo.email;
      this.profile.title = this.profileInfo.title;
      this.profile.address = Object.assign({}, this.profileInfo.address);
    }
  }
};
</script>

<style scoped lang="scss">
.v-list-item {
  .list-item {
    font-family: Palanquin;
    font-style: normal;
    font-size: 15px;
    line-height: 130%;
    color: #313131;
    letter-spacing: 0.05em;
    cursor: pointer;
    padding-left: 10px;
    padding-right: 10px;
  }
  min-height: 30px;
}
.text-input {
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0.75px;
  color: #0c1f36;
}
.text-transform {
  text-transform: capitalize !important;
  font-size: 14px;
}
.border-bottom {
  border-bottom: 1px solid lightgrey;
}
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none !important;
  border: 1px solid #e0e0e0 !important;
  margin: 0px;
}
</style>
